import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FinancePage } from '@/features/finance/pages/finance-page';

/** Income / expense report (Business and above); month, year or custom range (`from`..`to`), branch, and report / entries tab live in the URL. */
export const Route = createFileRoute('/_app/finance')({
  validateSearch: z.object({
    tab: z.enum(['report', 'entries']).optional().catch(undefined),
    grain: z.enum(['month', 'year', 'range']).optional().catch(undefined),
    period: z
      .string()
      .regex(/^\d{4}(-\d{2})?$/)
      .optional()
      .catch(undefined),
    from: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional()
      .catch(undefined),
    to: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional()
      .catch(undefined),
    branch: z.string().optional().catch(undefined),
    kind: z.enum(['expense', 'income']).optional().catch(undefined),
  }),
  component: FinancePage,
});
